import { useLenis } from "@/hooks/useLenis";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Marquee from "@/components/site/Marquee";
import Methodology from "@/components/site/Methodology";
import Classes from "@/components/site/Classes";
import Differentials from "@/components/site/Differentials";
import Reviews from "@/components/site/Reviews";
import Enrollment from "@/components/site/Enrollment";
import Footer from "@/components/site/Footer";

export default function Home() {
  useLenis();
  return (
    <main className="relative bg-cream">
      <Header />
      <Hero />
      <About />
      <Marquee />
      <Methodology />
      <Classes />
      <Differentials />
      <Reviews />
      <Enrollment />
      <Footer />
    </main>
  );
}
